import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.85)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backdropFilter: 'blur(4px)',
    padding: '16px',
  },
  modal: {
    background: '#111111',
    border: '1px solid #2a2a2a',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '440px',
    position: 'relative',
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  close: {
    position: 'absolute',
    top: '20px', right: '24px',
    background: 'none', border: 'none',
    color: '#a09890', fontSize: '1.2rem', cursor: 'pointer',
  },
  eyebrow: {
    fontFamily: 'Jost, sans-serif',
    fontSize: '0.7rem', fontWeight: 400,
    letterSpacing: '0.4em', textTransform: 'uppercase',
    color: '#c9a96e', marginBottom: '16px',
  },
  title: {
    fontFamily: 'Cormorant Garamond, serif',
    fontSize: '2.2rem', fontWeight: 300,
    color: '#f5f0eb', marginBottom: '32px',
  },
  input: {
    width: '100%', background: '#1a1a1a',
    border: '1px solid #2a2a2a', padding: '14px 16px',
    color: '#f5f0eb', fontFamily: 'Jost, sans-serif',
    fontSize: '0.85rem', fontWeight: 300,
    marginBottom: '16px', outline: 'none',
    boxSizing: 'border-box',
  },
  passwordWrapper: {
    position: 'relative',
    marginBottom: '16px',
  },
  passwordInput: {
    width: '100%', background: '#1a1a1a',
    border: '1px solid #2a2a2a', padding: '14px 48px 14px 16px',
    color: '#f5f0eb', fontFamily: 'Jost, sans-serif',
    fontSize: '0.85rem', fontWeight: 300,
    outline: 'none', boxSizing: 'border-box',
  },
  eyeBtn: {
    position: 'absolute', right: '14px', top: '50%',
    transform: 'translateY(-50%)',
    background: 'none', border: 'none',
    color: '#6b6460', cursor: 'pointer',
    fontSize: '1rem', padding: '4px',
    display: 'flex', alignItems: 'center',
  },
  button: {
    width: '100%', background: '#c9a96e',
    border: 'none', padding: '16px', color: '#0a0a0a',
    fontFamily: 'Jost, sans-serif', fontSize: '0.75rem',
    fontWeight: 400, letterSpacing: '0.2em',
    textTransform: 'uppercase', cursor: 'pointer', marginTop: '8px',
  },
  buttonDisabled: {
    width: '100%', background: '#4a3f2a',
    border: 'none', padding: '16px', color: '#6b5a3a',
    fontFamily: 'Jost, sans-serif', fontSize: '0.75rem',
    fontWeight: 400, letterSpacing: '0.2em',
    textTransform: 'uppercase', cursor: 'not-allowed', marginTop: '8px',
  },
  outlineBtn: {
    width: '100%', background: 'none',
    border: '1px solid #2a2a2a', padding: '14px', color: '#a09890',
    fontFamily: 'Jost, sans-serif', fontSize: '0.75rem',
    fontWeight: 400, letterSpacing: '0.2em',
    textTransform: 'uppercase', cursor: 'pointer', marginTop: '8px',
  },
  toggle: {
    marginTop: '20px', textAlign: 'center',
    fontFamily: 'Jost, sans-serif', fontSize: '0.8rem', color: '#a09890',
  },
  toggleLink: {
    color: '#c9a96e', cursor: 'pointer', marginLeft: '6px',
  },
  forgotLinks: {
    display: 'flex', justifyContent: 'space-between',
    marginBottom: '16px', marginTop: '-8px',
  },
  smallLink: {
    fontFamily: 'Jost, sans-serif', fontSize: '0.72rem',
    color: '#665e58', cursor: 'pointer', letterSpacing: '0.05em',
  },
  error: {
    color: '#e07070', fontFamily: 'Jost, sans-serif',
    fontSize: '0.8rem', marginBottom: '16px',
  },
  success: {
    color: '#7aad7a', fontFamily: 'Jost, sans-serif',
    fontSize: '0.85rem', marginBottom: '16px', lineHeight: 1.7,
  },
  backLink: {
    display: 'block', textAlign: 'center', marginTop: '20px',
    fontFamily: 'Jost, sans-serif', fontSize: '0.72rem',
    color: '#665e58', cursor: 'pointer', letterSpacing: '0.05em',
  },
  termsRow: {
    display: 'flex', alignItems: 'flex-start', gap: '10px',
    marginTop: '16px', marginBottom: '4px',
  },
  termsCheckbox: {
    marginTop: '2px', accentColor: '#c9a96e',
    cursor: 'pointer', flexShrink: 0, width: '15px', height: '15px',
  },
  termsText: {
    fontFamily: 'Jost, sans-serif', fontSize: '0.72rem',
    color: '#6b6460', lineHeight: 1.6,
  },
  termsLink: {
    color: '#c9a96e', textDecoration: 'none',
  },
};

const EyeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const EyeOffIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validatePassword = (password) => {
  const checks = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*()_+\-=\[\]{};':"\|,.<>\/?]/.test(password),
  };
  const passed = Object.values(checks).filter(Boolean).length;
  return { checks, score: passed };
};

const AuthModal = ({ mode, onClose, onSuccess }) => {
  const [view, setView] = useState(mode === 'login' ? 'login' : 'register');
  const [form, setForm] = useState({ username: '', email: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const reset = () => { setError(''); setSuccess(''); };

  const handleSubmit = async () => {
    reset();

    if (view === 'register') {
      if (form.username.length < 3 || form.username.length > 20) {
        return setError('Username must be between 3 and 20 characters');
      }
      if (!/^[a-zA-Z0-9]+$/.test(form.username)) {
        return setError('Username can only contain letters and numbers');
      }
      // Email format validation — catches autofill mistakes
      if (!emailRegex.test(form.email)) {
        return setError('Please enter a valid email address');
      }
      const { score } = validatePassword(form.password);
      if (score < 4) {
        return setError('Password must be at least 8 characters and include an uppercase letter, a number, and a special character');
      }
      if (form.password !== form.confirmPassword) {
        return setError('Passwords do not match');
      }
      if (!termsAccepted) {
        return setError('Please accept the Terms of Service to continue');
      }
    }

    if ((view === 'login' || view === 'forgot-password' || view === 'forgot-username') && form.email) {
      if (!emailRegex.test(form.email)) {
        return setError('Please enter a valid email address');
      }
    }

    setLoading(true);
    try {
      if (view === 'login') {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
          email: form.email, password: form.password,
        });
        localStorage.setItem('token', res.data.token);
        onSuccess(res.data.user, res.data.token);

      } else if (view === 'register') {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/register`, {
          username: form.username, email: form.email, password: form.password,
        });
        localStorage.setItem('pendingVerificationEmail', form.email);
        onClose();
        navigate('/verify-pending');

      } else if (view === 'forgot-password') {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, {
          email: form.email,
        });
        setSuccess('If an account exists with that email, a password reset link has been sent. Check your inbox.');

      } else if (view === 'forgot-username') {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/forgot-username`, {
          email: form.email,
        });
        setSuccess('If an account exists with that email, your username has been sent. Check your inbox.');
      }
    } catch (err) {
      if (err.response?.status === 403) {
        localStorage.setItem('pendingVerificationEmail', form.email);
        onClose();
        navigate('/verify-pending');
        return;
      }
      setError(err.response?.data?.error || 'Something went wrong');
    }
    setLoading(false);
  };

  const getEyebrow = () => {
    if (view === 'login') return 'Welcome Back';
    if (view === 'register') return 'Join Flakon';
    if (view === 'forgot-password') return 'Account Recovery';
    if (view === 'forgot-username') return 'Account Recovery';
  };

  const getTitle = () => {
    if (view === 'login') return 'Sign In';
    if (view === 'register') return 'Create Account';
    if (view === 'forgot-password') return 'Reset Password';
    if (view === 'forgot-username') return 'Find Username';
  };

  const getButtonLabel = () => {
    if (loading) return 'Please wait...';
    if (view === 'login') return 'Sign In';
    if (view === 'register') return 'Create Account';
    if (view === 'forgot-password') return 'Send Reset Link';
    if (view === 'forgot-username') return 'Send Username';
  };

  const isSubmitDisabled = loading || (view === 'register' && !termsAccepted);
  const showForm = !success;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <button style={styles.close} onClick={onClose}>✕</button>
        <p style={styles.eyebrow}>{getEyebrow()}</p>
        <h2 style={styles.title}>{getTitle()}</h2>

        {error && <p style={styles.error}>{error}</p>}
        {success && <p style={styles.success}>{success}</p>}

        {showForm && (
          <>
            {view === 'register' && (
              <>
                <input
                  style={styles.input}
                  name="username"
                  placeholder="Username"
                  autoComplete="username"
                  value={form.username}
                  onChange={handleChange}
                />
                <p style={{ fontSize: '0.65rem', color: '#3a3a3a', letterSpacing: '0.05em', marginTop: '-10px', marginBottom: '16px' }}>
                  3–20 characters, letters and numbers only
                </p>
              </>
            )}

            <input
              style={styles.input}
              name="email"
              placeholder="Email"
              type="email"
              autoComplete="email"
              value={form.email}
              onChange={handleChange}
            />

            {view === 'login' && (
              <>
                <div style={styles.passwordWrapper}>
                  <input
                    style={styles.passwordInput}
                    name="password"
                    placeholder="Password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="current-password"
                    value={form.password}
                    onChange={handleChange}
                  />
                  <button style={styles.eyeBtn} onClick={() => setShowPassword(p => !p)} tabIndex={-1}>
                    {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                </div>
                <div style={styles.forgotLinks}>
                  <span style={styles.smallLink} onClick={() => { reset(); setView('forgot-username'); }}>Forgot username?</span>
                  <span style={styles.smallLink} onClick={() => { reset(); setView('forgot-password'); }}>Forgot password?</span>
                </div>
              </>
            )}

            {view === 'register' && (
              <>
                <div style={styles.passwordWrapper}>
                  <input
                    style={styles.passwordInput}
                    name="password"
                    placeholder="Password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    value={form.password}
                    onChange={handleChange}
                  />
                  <button style={styles.eyeBtn} onClick={() => setShowPassword(p => !p)} tabIndex={-1}>
                    {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                </div>
                {form.password.length > 0 && (
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '-8px', marginBottom: '14px' }}>
                    {[
                      { key: 'length', label: '8+ chars' },
                      { key: 'uppercase', label: 'Uppercase' },
                      { key: 'number', label: 'Number' },
                      { key: 'special', label: 'Special char' },
                    ].map(({ key, label }) => {
                      const { checks } = validatePassword(form.password);
                      return (
                        <span key={key} style={{
                          fontSize: '0.58rem', letterSpacing: '0.1em', textTransform: 'uppercase',
                          padding: '3px 8px',
                          border: `1px solid ${checks[key] ? '#4a7a4a' : '#2a2a2a'}`,
                          color: checks[key] ? '#7aad7a' : '#3a3a3a',
                          background: checks[key] ? 'rgba(74,122,74,0.08)' : 'transparent',
                          transition: 'all 0.2s ease',
                        }}>
                          {checks[key] ? '✓ ' : ''}{label}
                        </span>
                      );
                    })}
                  </div>
                )}
                <div style={styles.passwordWrapper}>
                  <input
                    style={styles.passwordInput}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    type={showConfirmPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    value={form.confirmPassword}
                    onChange={handleChange}
                  />
                  <button style={styles.eyeBtn} onClick={() => setShowConfirmPassword(p => !p)} tabIndex={-1}>
                    {showConfirmPassword ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                </div>
                <div style={styles.termsRow}>
                  <input
                    type="checkbox"
                    style={styles.termsCheckbox}
                    checked={termsAccepted}
                    onChange={e => setTermsAccepted(e.target.checked)}
                    id="terms-checkbox"
                  />
                  <label htmlFor="terms-checkbox" style={styles.termsText}>
                    I agree to the{' '}
                    <a href="https://flakon.app/legal" target="_blank" rel="noreferrer" style={styles.termsLink}>Terms of Service</a>
                    {' '}and{' '}
                    <a href="https://flakon.app/legal" target="_blank" rel="noreferrer" style={styles.termsLink}>Privacy Policy</a>
                  </label>
                </div>
              </>
            )}

            <button
              style={isSubmitDisabled ? styles.buttonDisabled : styles.button}
              onClick={handleSubmit}
              disabled={isSubmitDisabled}
            >
              {getButtonLabel()}
            </button>

            {(view === 'login' || view === 'register') && (
              <div style={styles.toggle}>
                {view === 'login' ? "Don't have an account?" : 'Already have an account?'}
                <span style={styles.toggleLink} onClick={() => { reset(); setView(view === 'login' ? 'register' : 'login'); }}>
                  {view === 'login' ? 'Sign Up' : 'Sign In'}
                </span>
              </div>
            )}

            {(view === 'forgot-password' || view === 'forgot-username') && (
              <span style={styles.backLink} onClick={() => { reset(); setView('login'); }}>← Back to Sign In</span>
            )}
          </>
        )}

        {success && (
          <button style={styles.outlineBtn} onClick={onClose}>Close</button>
        )}
      </div>
    </div>
  );
};

export default AuthModal;